<template>
    <b-modal v-model="show" size="lg" title="Опции">
        <div class="container-fluid" style="max-height: 500px;overflow-y: auto">
            <table class="table table-no-border">
                <tr>
                    <th style="border-bottom: 1px solid #CCCCCC">Код</th>
                    <th style="border-bottom: 1px solid #CCCCCC">Название</th>
                    <th style="border-bottom: 1px solid #CCCCCC">Название(RU)</th>
                </tr>
                <tr v-for="(item, index) in data.items" :key="index">
                    <td style="border-top: 0">
                        <input type="text" class="form-control" v-model="item.code"/>
                    </td>
                    <td style="border-top: 0">
                        <input type="text" class="form-control" v-model="item.name"/>
                    </td>
                    <td style="border-top: 0">
                        <input type="text" class="form-control" v-model="item.nameRu"/>
                    </td>
                </tr>
            </table>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="btn btn-info float-left" @click="addItem">
                +
            </button>

            <button class="btn btn-success float-right" @click="apply">
                Apply
            </button>
            <button class="btn btn-default float-right mr-2" @click="cancel">
                Cancel
            </button>
        </div>
    </b-modal>
</template>

<script>
    import {BModal, VBModal} from 'bootstrap-vue';
    // import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    export default {
        name: "CategoryParamOptionsModal",
        components: {
            'b-modal': BModal
        },
        directives: {
            'b-modal': VBModal
        },
        data() {
            return {
                show: false,
                data: {
                    items: []
                }
            }
        },
        methods: {
            cancel() {
                this.show = false;
            },
            apply() {
                const items = [];
                this.data.items.forEach((item) => {
                    if (item.code && item.code.length > 0 && item.name && item.name.length > 0) {
                        items.push(item);
                    }
                });
                this.data.items = items;
                this.$emit('apply', this.data);
                this.show = false;
            },
            addItem() {
                this.data.items.push({
                    code: '',
                    name: ''
                });
            }
        },
        created() {
            this.$eventBus.$on('modalParamOptions', (data) => {
                if (!data) {
                    data = {}
                }
                if (data.items && data.items.length > 0) {
                    this.data = data;
                } else {
                    data.items = [];
                    this.data = data;
                    this.addItem();
                }
                this.show = true;
            });
        }
    }
</script>

<style scoped>

</style>